import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopPropagation
  from '@mailobj-browser/front/js/events/hooks/stopPropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { formAction, post } from '#utilities/js/ea/ajax.js'
import globals from '#utilities/js/ea/globals.js'
import { shim } from '#utilities/js/ea/submitter.js'
import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import { elements } from '../../../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

const forms = new WeakMap()

const onSubmit = object(listener, {
  type: submit,
  task: async (
    form,
    event
  ) => {
    const { ownerDocument } = form
    const { submitter } = shim(event)
    const { name, value, dataset } = submitter
    const { target, confirm } = dataset

    if (name === 'save_copy' || name === 'save_auto') {
      preventDefault(event)
      stopPropagation(event)

      const { contentDocument } = one(`iframe[data-rte='mail']`, ownerDocument)
      const { body: bodyIframe } = contentDocument

      if (contentDocument) {
        const { defaultView } = ownerDocument
        const { FormData } = defaultView
        const body = new FormData(form)

        body.set(name, value)
        body.set('msg_text', bodyIframe.innerHTML)

        await post(formAction(form, submitter), body, { target: form })
      }

      close()
    } else if (name === 'send' || name === 'change') {
      globals.ea_link_msg_set(null)
      const result = globals.ea_form(submitter, target ?? '', confirm ?? null)

      if (!result) {
        preventDefault(event)
        stopPropagation(event)
      }
    }
  }
})

export default form => {
  const { ownerDocument } = form
  const { body } = ownerDocument

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    // Ajoute une class pour gérer la hauteur de l'iframe
    await inserted(form, body)
    sharedClasses.add(form, elements.send)
  })

  onSubmit.listen(form)

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    // Ajoute une class pour gérer la hauteur de l'iframe
    await removed(form)

    sharedClasses.remove(form, elements.send)
  })
}
